<template>
  <div>
    <!-- Job Detail Page Container starts here -->
    <div v-if="!loading" class="job-detail-container">
      <div class="heading-container">
        <TopButtonsComponent
          v-bind:jobCreatorId="jobCreatorId"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
          v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
          v-bind:isJobDetailPage='isJobDetailPage'
          v-bind:jobId="jobId"
          v-on:editJob="$emit('editJob', jobId)"
        />
      </div>

      <!-- Job Detail Summary Cards Starts Here -->
      <div class="job-detail-summary-cards-container">
        <JobDetailSummaryCard
          v-bind:cardIcon="applicationsCountIcon"
          v-bind:summaryDescription="applicationsCountDescription"
          v-bind:totalCount="applicationsCount"
        />
        <JobDetailSummaryCard
          v-bind:cardIcon="inReviewCountIcon"
          v-bind:summaryDescription="inReviewCountDescription"
          v-bind:totalCount="inReviewCount"
        />
        <JobDetailSummaryCard
          v-bind:cardIcon="shortlistedCountIcon"
          v-bind:summaryDescription="shortlistedCountDescription"
          v-bind:totalCount="shortlistedCount"
        />
        <JobDetailSummaryCard
          v-bind:cardIcon="invitedCountIcon"
          v-bind:summaryDescription="invitedCountDescription"
          v-bind:totalCount="invitedCount"
        />
        <JobDetailSummaryCard
          v-bind:cardIcon="hiredCountIcon"
          v-bind:summaryDescription="hiredCountDescription"
          v-bind:totalCount="hiredCount"
        />
        <JobDetailSummaryCard
          v-bind:cardIcon="declinedCountIcon"
          v-bind:summaryDescription="declinedCountDescription"
          v-bind:totalCount="declinedCount"
        />
      </div>
      <!-- Job Detail Summary card ends here -->

      <!-- Job Detail Application and Detail Container starts here -->
      <div class="job-detail-info-container">
        <JobInfo
          v-bind:userJob="userJob"
          v-bind:companyName="userJob.companyName"
          v-bind:jobLocation="jobLocation"
          v-bind:deadline="userJob.jobDeadline"
          v-bind:description="userJob.jobDescription"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
        />
        <UserApplications
          v-bind:jobHeading="jobHeading"
          v-bind:jobName="userJob.title"
          v-bind:jobApplications="applicationsWithApplicants"
          v-bind:jobLocation="jobLocation"
          v-on:viewApplication="viewApplicationDetails"
        />
      </div>
      <!-- Job Detail Application and Detail Container ends here -->
    </div>

    <!-- Job Detail Page Container ends here -->

    <!-- Loader Component -->
    <Loader
      v-if="loading"
    />
  </div>
</template>
<script>
// import axios from 'axios'

import Api from '../../services/Api';
import config from '../../../vue.config';

import TopButtonsComponent from './TopButtonsComponent.vue';
import JobInfo from './JobInfo.vue';
import UserApplications from './UserApplications.vue';
import JobDetailSummaryCard from './JobDetailSummaryCard.vue';
import Loader from '../body/Loader.vue';

import inReviewCountIcon from '../../assets/images/in-review-icon.png';
import applicationsCountIcon from '../../assets/images/total-applications.png';
import shortlistedCountIcon from '../../assets/images/total-shortlisted.png';
import invitedCountIcon from '../../assets/images/invited-icon.png';
import hiredCountIcon from '../../assets/images/hired-icon.png';
import declinedCountIcon from '../../assets/images/declined-icon.png';

export default {
  name: 'JobDetail',
  props: [],
  components: {
    TopButtonsComponent,
    JobDetailSummaryCard,
    JobInfo,
    UserApplications,
    Loader
  },

  data() {
    return {
      isJobDetailPage: true,
      jobId: null,
      jobHeading: 'Applications',
      inReviewCountIcon,
      applicationsCountIcon,
      shortlistedCountIcon,
      invitedCountIcon,
      hiredCountIcon,
      declinedCountIcon,

      loading: false,

      userJob: '',

      jobError: '',

      applicationError: '',
      applicationsCountDescription: 'Total Applications',
      applicationsCount: 0,
      allApplications: [],
      applicationsWithApplicants: [],

      inReviewCountDescription: 'In-review Applications',
      inReviewCount: 0,
      inReviewList: [],

      shortlistedCountDescription: 'Shortlisted Applications',
      shortlistedCount: 0,
      shortlistedList: [],

      invitedCountDescription: 'Invited for Interview',
      invitedCount: 0,
      invitedList: [],

      hiredCountDescription: 'Hired Applications',
      hiredCount: 0,
      hiredList: [],

      declinedCountDescription: 'Declined Applications',
      declinedCount: 0,
      declinedList: []
    };
  },
  methods: {
    viewApplicationDetails(applicationId) {
      this.$emit('viewApplication', applicationId);
    }
  },
  computed: {
    jobLocation() {
      if (!this.userJob.city) {
        return `${this.userJob.state}`;
      }
      if (!this.userJob.state) {
        return `${this.userJob.city}`;
      }
      if (!this.userJob.city && !this.userJob.state) {
        return null;
      }

      return `${this.userJob.city}, ${this.userJob.state}`;
    },
    jobCreatorId() {
      return this.userJob.creator
          ? this.userJob.creator
          : this.userJob.agencyCreator;
    }
  },
  async beforeMount() {
    this.loading = true;
    this.jobId = this.$router.history.current.params.jobID;

    const endpoint = `${config.devServer.proxy}/job/${this.jobId}`;

    await Api()
      .get(endpoint)
      .then((res) => {
        this.userJob = res.data.data;
        this.userJob.jobDeadline = this.userJob.jobDeadline ? new Date(this.userJob.jobDeadline + 'T00:00:00').toDateString() : null;

        this.allApplications = this.userJob.applications;
        this.applicationsCount = this.userJob.applications.length;

        for (let application of this.allApplications) {
          switch (application.status) {
            case 'in-review':
              this.inReviewList.push(application);
              break;

            case 'shortlisted':
              this.shortlistedList.push(application);
              break;

            case 'scheduled-for-interview':
              this.invitedList.push(application);
              break;

            case 'hired':
              this.hiredList.push(application);
              break;

            case 'declined':
              this.declinedList.push(application);
              break;
          }
        }

        this.inReviewCount = this.inReviewList.length;
        this.shortlistedCount = this.shortlistedList.length;
        this.invitedCount = this.invitedList.length;
        this.hiredCount = this.hiredList.length;
        this.declinedCount = this.declinedList.length;

        // this.loading = false;
      })
      .catch((err) => {
        this.$toastr.error(err.response.data.error, 'Failed');
      });

    const endpoint2 = `${config.devServer.proxy}/job/${this.jobId}/applicants`;

    await Api()
      .get(endpoint2)
      .then((res) => {
        this.applicationsWithApplicants = res.data.data;
      })
      .catch((err) => {
        this.$toastr.error(err.response.data.error, 'Failed');
      });

    this.loading = false;
  },
  mounted() {

  },
  updated() {

  }
};
</script>

<style scoped>
  .job-detail-summary-cards-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .job-detail-info-container {
    display: grid;
    grid-template-columns: 3fr 1fr;
    margin-top: 40px;
    gap: 40px;
  }

  .job-detail-container .job-detail-heading {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1078px) {
    .job-detail-info-container {
      display: grid;
      grid-template-columns: 2fr; /* Previous Working Value: 2fr 1fr */
    }
  }

  @media only screen and (max-width: 990px) {
    .job-detail-info-container {
      display: block;
    }
  }

  @media only screen and (max-width: 767px) {
  }

  @media only screen and (max-width: 565px) {
  }

  @media only screen and (max-width: 420px) {
  }
</style>
